export const FIELD_IS_REQUIRED = "Field is required";
export const INVALID_SELECTION = "Invalid selection";
export const START_TIME_SHOULD_BE_LESS_THAN_END_TIME = "Start time should be less than end time";
export const END_TIME_SHOULD_BE_GREATER_THAN_START_TIME = "End time should be greater than start time";
export const INVALID_IMAGE_URL_MESSAGE = "Invalid image URL";
export const MANUAL_VIDEO_REQUEST_MAX_DURATION_EXCEEDED =
    "The maximum duration for a manual video request is 30 minutes. Please adjust your selection.";
export const WARNING_DATE_FILTERING_DISABLED_BY_APPLIED_PRE_FILTER =
    "Date filtering is disabled by the current pre-filter. Please remove the pre-filter to enable date selection.";
